// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询门店列表 GET /api/v1/stores */
export async function StoreControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.StoreControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStoreDtoArray>("/api/v1/stores", {
    method: "GET",
    params: {
      // pageSize has a default value: 10
      pageSize: "10",

      // logicOperator has a default value: and
      logicOperator: "and",

      // sortOrder has a default value: DESC
      sortOrder: "DESC",
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建门店 POST /api/v1/stores */
export async function StoreControllerCreateV1(
  body: MyApi.CreateStoreDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStoreDto>("/api/v1/stores", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询门店详情 GET /api/v1/stores/${param0} */
export async function StoreControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.StoreControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStoreDto>(`/api/v1/stores/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 更新门店 PUT /api/v1/stores/${param0} */
export async function StoreControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.StoreControllerUpdateV1Params,
  body: MyApi.UpdateStoreDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStoreDto>(`/api/v1/stores/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除门店（软删除） DELETE /api/v1/stores/${param0} */
export async function StoreControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.StoreControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/stores/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 生成门店支付宝二维码 POST /api/v1/stores/${param0}/alipay-qrcode */
export async function StoreControllerGenerateAlipayQrcodeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.StoreControllerGenerateAlipayQrcodeV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseString>(
    `/api/v1/stores/${param0}/alipay-qrcode`,
    {
      method: "POST",
      params: {
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}
